import React from "react";
import CustomModal from "../CustomModal";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      ...this.state,
      error,
      errorInfo,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <CustomModal
          showModal={true}
          setShowModal={() => this.setState({ hasError: false })}
          heading="Error!"
          isErrorModal={true}
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
